module.exports = __webpack_public_path__ + "assets/loops.5a6cf381.svg";